
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

gsap.defaults({overwrite: 'auto'});

const ST = ScrollTrigger.create({
  trigger: ".banner__content",
  start: "top top",
  end: "bottom bottom",
  onEnter: () => {
  	setTimeout(function(){
  		$('.banner').addClass('load-banner')
	}, 1000);
  },
  pin: ".banner__info"
});

let contentMarkers = gsap.utils.toArray(".banner__item"),
	// observer = ScrollTrigger.normalizeScroll(true),
    scrollTween;

function goToSection(i) {
	gsap.set('#banner', {className: 'slide-' + i}); 
  	scrollTween = gsap.to(window, {
		scrollTo: {y: i * innerHeight, autoKill: false},
		onStart: () => {
		  observer.disable(); // for touch devices, as soon as we start forcing scroll it should stop any current touch-scrolling, so we just disable() and enable() the normalizeScroll observer
		  observer.enable();
		},
		duration: 1,
		onComplete: () => scrollTween = null,
		overwrite: true
	});
}

contentMarkers.forEach((panel, i) => {
  ScrollTrigger.create({
    trigger: panel,
    start: "top bottom",
    end: "+=198%",
    onToggle: self => {
    	self.isActive && !scrollTween && goToSection(i)
    }
  });
});

const media = window.matchMedia("screen and (max-height: 400px)");
ScrollTrigger.addEventListener("refreshInit", checkSTState);
checkSTState();

function checkSTState() {
  if(media.matches) {
    ST.disable();
  } else {
    ST.enable();
  }
}
